// import { color } from 'framer-motion';
// import React from 'react';
// import { FaEnvelope, FaFacebook, FaLinkedin, FaInstagram, FaPhoneAlt } from 'react-icons/fa';
// import usa from '../Images/usamap.png'
// import india from '../Images/india map.png'


// const OurLocations = () => {
//   return (
//     <div style={styles.container}>

//       <h2 style={styles.heading}>
//         Our <span style={styles.orangeText}>Locations</span>
//       </h2>
//       <div style={styles.locationsContainer}>

//         <div style={styles.locationBox}>
//           {/* <div style={styles.locationTitle}> 🇮🇳 India Office</div> */}
//           <div style={styles.locationTitle}>
//             <img
//               src={india} // Replace with your actual image path
//               alt="USA map"
//               style={styles.flagIcon}
//             />
//             INDIA OFFICE
//           </div>
//           <div style={styles.address}>
//             418 Platinum 9, Pashan-Sus Road, Behind Audi <br />
//             Showroom, Baner, Pune MH-411045
//           </div>
//           {/* <span style={styles.phone}>📞 9860099980 /  91583376668</span> */}
//           <div style={styles.phone}>
//             <FaPhoneAlt style={{ marginRight: '8px' }} /> 9860099980 /  91583376668
//           </div>
//           <a href="https://www.google.com/maps/dir//Platinum+9+No.+52%2F5+Sr+1,+Pashan+-+Sus+Rd,+near+Audi+Showroom,+Baner,+Pune,+Maharashtra+411045/@18.5485197,73.7691774,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bc2bee9fafbc545:0x7ba7e43566bcaa7d!2m2!1d73.7691774!2d18.5485197?entry=ttu&g_ep=EgoyMDI1MDczMC4wIKXMDSoASAFQAw%3D%3D" style={styles.link}>GET DIRECTIONS ➤</a>

//         </div>

//         <div style={styles.locationBox}>

//           {/* <div style={styles.locationTitle}> 🇺🇸 USA Office</div> */}
//           <div style={styles.locationTitle}>
//             <img
//               src={usa} // Replace with your actual image path
//               alt="USA map"
//               style={styles.flagIcon}
//             />
//             USA OFFICE
//           </div>
//           <div style={styles.address}>
//             12703 dorsett rd a, maryland heights,<br />
//             mo, 63043-2291, united states

//           </div>
//           {/* <span style={styles.phone}>📞 +1 314-479-3530</span> */}
//           <div style={styles.phone}>
//             <FaPhoneAlt style={{ marginRight: '8px' }} /> +1 314-479-3530
//           </div>
//           <a href="https://www.google.com/maps/dir//Platinum+9+No.+52%2F5+Sr+1,+Pashan+-+Sus+Rd,+near+Audi+Showroom,+Baner,+Pune,+Maharashtra+411045/@18.5485197,73.7691774,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bc2bee9fafbc545:0x7ba7e43566bcaa7d!2m2!1d73.7691774!2d18.5485197?entry=ttu&g_ep=EgoyMDI1MDczMC4wIKXMDSoASAFQAw%3D%3D" style={styles.link}>GET DIRECTIONS ➤</a>
//         </div>

//         {/* <div style={styles.locationBox}>
//           <div style={styles.locationTitle}>Seattle Office</div>
//           <div style={styles.address}>
//             14980 NE 31st Way, Suite 120<br />
//             Redmond, WA 98052
//           </div>
//           <a href="#" style={styles.link}>GET DIRECTIONS ➤</a>
//         </div> */}

//       </div>

//       <div style={styles.socialContainer}>
//         <div style={styles.socialTitle}>Join the StructGuard Social Community</div>
//         <div style={styles.socialIcons}>
//           <a href="https://www.linkedin.com/company/structguard-engineers-llp/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
//             <div style={styles.socialIcon}>
//               <FaLinkedin style={{ marginRight: '8px' }} /> LinkedIn
//             </div>
//           </a>
//           <a href="https://www.facebook.com/structguard" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
//             <div style={styles.socialIcon}>
//               <FaFacebook style={{ marginRight: '8px' }} /> Facebook
//             </div>
//           </a>
//           <a href="https://www.instagram.com/structguard.e/profilecard/?igsh=eWM4bDdjcTNtYmU2" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
//             <div style={styles.socialIcon}>
//               <FaInstagram style={{ marginRight: '8px' }} /> Instagram
//             </div>
//           </a>
//           {/* <a href="mailto:info@structguard.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
//             <div style={styles.socialIcon}>
//               <FaEnvelope style={{ marginRight: '8px' }} /> Gmail
//             </div>
//           </a> */}
//         </div>
//       </div>


//     </div >
//   );
// };

// const styles = {
//   container: {
//     // background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
//     backgroundcolor: '#fff',
//     color: '#0A1733',
//     // padding: '2rem',
//     margin: '5px',
//     fontFamily: 'Segoe UI, sans-serif',
//     // border: '2px solid black',
//     borderRadius: '12px',

//   },
//   heading: {
//     fontSize: '2rem',
//     fontWeight: 'bold',
//     textAlign: "center",
//     color: "#0A1733"
//   },
//   orangeText: {
//     color: '#f37021',
//   },
//   socialIcon: {
//     background: '#00aaff',
//     color: '#fff',
//     padding: '0.6rem 1rem',
//     borderRadius: '6px',
//     fontSize: '1rem',
//     display: 'flex',
//     alignItems: 'center',
//     margin: '0.3rem',
//     transition: 'background 0.3s ease',
//     cursor: 'pointer',
//   },

//   sectionTitle: {
//     textAlign: 'center',
//     fontSize: '2rem',
//     marginBottom: '2rem',
//     fontWeight: 'bold',
//     // textDecoration: 'underline',
//     // borderBottom: '2px solid black',
//     paddingBottom: '6px',   // This adds space between text and line
//     // display: 'inline-block'
//   },
//   locationsContainer: {
//     display: 'flex',
//     flexWrap: 'wrap',
//     justifyContent: 'space-between',
//     backgroundColor: 'rgba(255,255,255,0.05)',
//     padding: '1.5rem',
//     borderRadius: '12px',

//   },
//   locationBox: {
//     flex: '1 1 30%',
//     padding: '1rem',
//     minWidth: '260px',
//   },
//   mapImage: {
//     width: '100%',
//     borderRadius: '8px',
//     marginBottom: '1rem',
//   },
//   locationTitle: {
//     display: 'inline-flex',           // to align image and text
//     alignItems: 'center',
//     fontSize: '1.2rem',
//     fontWeight: 'bold',
//     borderBottom: '2px solid black', // replaces underline
//     paddingBottom: '6px',            // spacing between text and line
//     gap: '8px'                       // spacing between image and text
//   },
//   flagIcon: {
//     width: '20px',
//     height: '20px',
//     objectFit: 'contain'
//   },
//   address: {
//     fontSize: '0.9rem',
//     lineHeight: '1.4',
//   },
//   phone: {
//     marginTop: '0.5rem',
//     fontWeight: 'bold',
//     display: 'block',
//     color: '#00aaff',
//   },
//   link: {
//     marginTop: '0.5rem',
//     display: 'inline-block',
//     color: '#fff',
//     textDecoration: 'underline',
//     fontWeight: 'bold',
//   },
//   socialContainer: {
//     // background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
//     backgroundcolor: '#fff',

//     padding: '2rem',
//     marginTop: '2rem',
//     borderRadius: '8px',
//     textAlign: 'center',
//   },
//   socialTitle: {
//     fontSize: '1.5rem',
//     marginBottom: '1rem',
//     fontWeight: 'bold',
//     color: 'grey'
//   },
//   socialIcons: {
//     display: 'flex',
//     justifyContent: 'center',
//     flexWrap: 'wrap',
//     gap: '1rem',
//   },
//   socialIcon: {
//     background: '#fff',
//     color: '#0279c3',
//     padding: '0.7rem 1.5rem',
//     borderRadius: '30px',
//     fontWeight: 'bold',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.5rem',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//   },
// };
// export default OurLocations;


import { color } from "framer-motion";
import React from "react";
import { FaFacebook, FaLinkedin, FaInstagram, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import sgwhite from '../Images/sgwgite.png'
import { motion } from "framer-motion";
import './Footer.css';
import TypingHeading from './TypingHeading';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      {/* <div style={styles.wave}>

        <svg
          style={styles.waveSvg}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.24c58-19.6,122.16-29.91,184.28-28.09,
            72.05,2.11,142.63,22.45,212.25,41.27,
            67.28,18.12,134.81,35.16,203.25,34.39,
            59.66-.65,117.78-14.25,177.14-27.84,
            62.81-14.45,127.4-28.9,192.14-27.65V0H0V27.35
            A600.21,600.21,0,0,1,321.39,56.24Z"
            style={styles.waveShape}
          ></path>
        </svg>
      </div> */}

      <div style={styles.topSection}>
        {/* Logo + Company Info */}

        {/* <img
          src={sgwhite} // <-- replace with actual path where you saved logo
          alt="StructGuard Logo"
          style={{ width: "120px", height: "auto", marginBottom: "10px" }}
        /> */}
        <div style={styles.brand}>
          <h2 style={styles.logo}>Struct<span style={{ color: "white" }}>Guard</span></h2>
          <h3 style={styles.tagline}>
            Designing Innovative Structures for a Sustainable Future
          </h3>
          {/* <p style={styles.description}>
            As we work on non-traditional materials like CFS, Wood. also we work on innovative projects which are non-traditional.
          </p> */}
        </div>




        {/* Quick Links */}
        <div style={{ ...styles.links, ...styles.divider }}>
          <h3 style={styles.sectionTitle}>Quick Links</h3>
          <ul style={styles.linkList}>

            {/* <li>
              <motion.a
                href="/"
                style={styles.link}
                whileHover={{
                  scale: 1.1,
                  color: "#f37021",
                  x: 5
                }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                Home22
              </motion.a>
            </li> */}
            <li><a href="/" className="footer-link">Home</a></li>
            <li><a href="/about" className="footer-link">About Us</a></li>
            <li><a href="/projects" className="footer-link">Projects</a></li>
            <li><a href="/contact" className="footer-link">Contact</a></li>

            {/* <li><a href="/" style={styles.link}>Home</a></li>
            <li><a href="/about" style={styles.link}>About Us</a></li>
            <li><a href="/projects" style={styles.link}>Projects</a></li>
            <li><a href="/contact" style={styles.link}>Contact</a></li> */}

          </ul>
        </div>

        {/* Contact Info */}
        {/* <div style={{ ...styles.contact, ...styles.divider }}>
          <h3 style={styles.sectionTitle}>Contact</h3>
          <p><FaMapMarkerAlt style={styles.icon} /> Pune, India | USA Office</p>
          
          <p><FaPhoneAlt style={styles.icon} /> +91 9860099980 | +1 314-479-3530</p>
          <p><FaEnvelope style={styles.icon} /> info@structguard.com</p>
        </div> */}

        {/* Contact Info */}
        <div style={{ ...styles.contact, ...styles.divider }}>
          <h3 style={styles.sectionTitle}>Offices</h3>

          <div style={styles.contactWrapper} className="footer-offices">
            {/* Pune Office */}
            <div style={styles.office}>
              <h4 style={styles.officeTitle}>INDIA </h4>

              <div style={styles.line}>
                <FaMapMarkerAlt style={styles.iconloc} />
                <div style={styles.textBlock}>
                  418 Platinum 9, Pashan-Sus Road, Behind Audi Showroom, Baner, Pune, MH-411045, INDIA
                </div>
              </div>

              <div style={styles.line}>
                <FaPhoneAlt style={styles.iconloc} />

                <span style={styles.phone}>+91 98 6009 9980</span>

              </div>

              <p  >
                <FaEnvelope style={styles.icon} /> info@structguard.com
              </p>
            </div>

            {/* USA Office */}
            <div style={styles.office}>

              <h4 style={styles.officeTitle}>UNITED STATES OF AMERICA</h4>

              <div style={styles.line}>
                <FaMapMarkerAlt style={styles.iconloc} />
                <div style={styles.textBlock}>
                  2607 Buckeye Circle<br />
                  Blue Bell,PA 19422<br />
                  UNITED STATES OF AMERICA
                </div>
              </div>

              <div style={styles.line}>
                <FaPhoneAlt style={styles.iconloc} />
                {/* <div style={{ ...styles.textBlock,  display: "inline-block", paddingBottom: "4px",      borderBottom: "2px solid #F37021"}}>
                  +1 314-479-3530
                </div> */}
                <span style={styles.phone}>+1 314 479 3530</span>
              </div>
              <p  >
                <FaEnvelope style={styles.icon} /> hr@structguard.com
              </p>

            </div>

          </div>



        </div>

        {/* Social Links */}
        <div style={{ ...styles.social, ...styles.divider }}>
          <h3 style={styles.sectionTitle}>Follow Us</h3>

          <div style={styles.socialIcons}>
            <motion.a
              href="https://www.linkedin.com/company/structguard-engineers-llp/"
              target="_blank"
              rel="noreferrer"
              whileHover={{ y: -5, scale: 1.1, color: "#0A66C2" }}
              transition={{ type: "spring", stiffness: 300 }}
              style={{ color: "white" }}
            >
              <FaLinkedin style={{ fontSize: "24px" }} />
            </motion.a>

            <motion.a
              href="https://www.facebook.com/profile.php?id=61584341936280"
              target="_blank"
              rel="noreferrer"
              // whileHover={{ scale: [1, 1.3, 1], rotate: [0, -15, 0], color: "#4D87FF" }}
              // transition={{ duration: 0.6, ease: "easeInOut" }}
              whileHover={{ y: -5, scale: 1.1, color: "#4D87FF" }}
              transition={{ type: "spring", stiffness: 300 }}
              style={{ color: "white" }}
            >
              <FaFacebook style={{ fontSize: "24px" }} />
            </motion.a>

            <motion.a
              href="https://www.instagram.com/structguard.e"
              target="_blank"
              rel="noreferrer"
              // whileHover={{ scale: [1, 1.3, 1], rotate: [0, 20, 0], color: "" }}
              // transition={{ duration: 0.6, ease: "easeInOut" }}
              whileHover={{ y: -5, scale: 1.1, color: "#E4405F" }}
              transition={{ type: "spring", stiffness: 300 }}
              style={{ color: "white" }}
            >
              <FaInstagram style={{ fontSize: "24px" }} />
            </motion.a>
          </div>
        </div>




      </div>

      {/* Bottom Section */}
      <div style={styles.bottomSection}>
        <p>© {new Date().getFullYear()} StructGuard Engineers LLP. All Rights Reserved.</p>
      </div>

    </footer>


  );
};

const styles = {
  footer: {
    background: "#0A1733",
    color: "#fff",
    // marginTop: "3rem",
    // paddingTop: "2rem",
    // borderTopLeftRadius: "80px",
    // borderTopRightRadius: "80px",
    // borderTop: "6px solid #f37021",
    // position:'fixed'
  },
  divider: {
    borderLeft: "1px solid rgba(255,255,255,0.2)",
    paddingLeft: "1.5rem",
  },

  wave: {
    position: "absolute",
    top: "-60px",     // adjust wave height
    left: 0,
    width: "100%",
    overflow: "hidden",
    lineHeight: 0,
    transform: "rotate(180deg)", // so wave faces down into footer
  },
  waveSvg: {
    position: "relative",
    display: "block",
    width: "calc(100% + 1.3px)",
    height: "60px",
  },
  waveShape: {
    fill: "red", // 🔶 orange wave color
  },
  topSection: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    gap: "2rem",
    padding: "0 2rem",
  },
  brand: {
    flex: "1 1 250px",
  },
  logo: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: '#f37021'
  },
  tagline: {
    fontSize: "1.25rem",
    color: "#ccc",
    // marginTop: "0.5rem",
    // maxWidth: "250px",
  },
  description: {
    fontSize: "1 rem",
    color: "#666",
    // marginTop: "0.75rem",
    maxWidth: "600px", // keeps text clean
    lineHeight: "1.5",
  },
  links: {
    flex: "1 1 150px",
  },
  sectionTitle: {
    fontSize: "1.2rem",
    marginBottom: "0.5rem",
    color: "#f37021",
  },
  linkList: {
    listStyle: "none",
    padding: 0,
  },
  link: {
    textDecoration: "none",
    color: "#fff",
    display: "block",
    marginBottom: "0.4rem",
    transition: "color 0.3s",
  },
  contact: {
    flex: "1 1 200px",
    fontSize: "0.9rem",
    lineHeight: "1.6",
  },
  icon: {
    marginRight: "8px",
    color: "#f37021",
  },
  social: {
    flex: "1 1 150px",
  },
  socialIcons: {
    display: "flex",
    gap: "12px",
    fontSize: "1.4rem",

  },
  bottomSection: {
    textAlign: "center",
    padding: "1rem",
    marginTop: "1.5rem",
    borderTop: "1px solid rgba(255,255,255,0.1)",
    fontSize: "0.85rem",
    color: "#aaa",
  },

  // contactWrapper: { display: "flex", flexWrap: "wrap", gap: "2rem", marginBottom: "1rem", },

  contactWrapper: {
    display: "flex",
    gap: "2rem",
    alignItems: "stretch", // 🔑 equal height cards
  },
  office: {
    flex: "1 1 50%",        // each office 50% width
    minWidth: "300px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  line: {
    display: "flex",
    alignItems: "flex-start", // icon stays top
    gap: "0.5rem",
    flex: "1 1 0",            // 🔑 equal height per line
  },

  iconloc: {
    color: "#f37021",
    marginTop: "3px",
  },

  textBlock: {
    flex: 1,
    lineHeight: "1.5rem",
    display: "flex",
    alignItems: "center",     // vertical balance
  },

  officeTitle: {
    fontSize: "1rem",
    fontWeight: "bold",
    marginBottom: "0.5rem",
    color: "#f37021",
    minHeight: "2.5rem",  // ensures equal height for both titles
    display: "flex",
    alignItems: "center", // vertically centers shorter titles
  },

  // line: {
  //   display: "flex",
  //   alignItems: "flex-start", // icon top-aligned
  //   marginBottom: "0.5rem",
  // },

  // iconloc: {
  //   marginRight: "8px",
  //   marginTop: "4px",        // keeps icon aligned with first line of text
  //   color: "#f37021",
  //   flexShrink: 0,
  // },

  // textBlock: {
  //   flex: 1,
  //   lineHeight: "1.5",
  // },

  // contactWrapper: {
  //   display: "flex",
  //   flexWrap: "wrap",
  //   gap: "2rem",
  //   // marginBottom: "1rem",
  //   alignItems: "stretch",   // makes both offices equal height
  // },

  // office: {
  //   flex: "1 1 50%",         // 50% width each → always equal
  //   minWidth: "280px",       // responsive fallback
  // },

  // officeTitle: {
  //   fontSize: "1rem",
  //   fontWeight: "bold",
  //   marginBottom: "0.5rem",
  //   color: "#f37021",
  //   textTransform: "uppercase",
  // },

  phone: {
    // textDecoration: "underline", // underline phone numbers
    display: "inline-block",
    paddingBottom: "4px",      // space between text & underline
    borderBottom: "2px solid #F37021"
  },


};

export default Footer;
